import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList
} from "@angular/cdk/drag-drop";
import {RoutePanelModel} from "../../../models/route-panel.model";
import {RoutesViewSettingsModel} from "../../../models/routes-view-settings.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {TaskType} from "../../../../tasks/types/task.type";
import {RouteModel} from "../../../models/route.model";
import {RoutesComponentStore} from "../../state/routes.store";
import {Observable, Subject, Subscription} from "rxjs";
import * as moment from "moment";
import {debounceTime} from "rxjs/operators";
import {Service} from "../../../../deliveries/models/service.model";
import {RoutesDragAndDropService} from "../../services/routes-drag-and-drop.service";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  TaskRelationsPopupComponent,
  TaskRelationsPopupData
} from "../../../../commons/angular/components/task-relations-popup/task-relations-popup.component";
import {TasksHttpService} from "../../../../tasks/angular/services/tasks-http.service";
import {dedupeRelationsByService} from "../../../../tasks/utils/task-relations.util";
import {TaskRelationModel} from "../../../../tasks/models/task-relation.model";

const DEBOUNCE_TIME: number = 150;

require('./routes-panel-route-view.scss');
@Component({
  standalone: false,
  selector: 'app-routes-panel-route-view',
  templateUrl: './routes-panel-route-view.html',
  providers: [RoutesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesPanelRouteViewComponent implements OnInit, OnChanges {

  @Input() index: any;
  @Input() panel: RoutePanelModel;
  @Input() route: RouteModel;
  @Input() panels: RoutePanelModel[];
  @Input() settings: RoutesViewSettingsModel;
  @Input() visibleIds: string[];
  @Input() selectedServiceIds: string[];
  @Input() highlightedActivity?: any;
  @Input() isLoading: boolean;
  @Input() ungroupedRouteIds: Set<string>;
  @Input() expandedRoutes: any[] = [];
  @Input() resourcesDropListIds?: string[];
  @Input() routesDropListIds?: string[];
  @Output() onSelect = new EventEmitter();
  @Output() onViewJob = new EventEmitter<boolean>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onLockRouteChange = new EventEmitter<{id: string, locked: boolean}>();
  @Output() onMoveTask = new EventEmitter();
  @Output() onAddStopsToRoute = new EventEmitter();
  @Output() onToggleVisible = new EventEmitter<boolean>();
  @Output() onSelectServices = new EventEmitter<string[]>();
  @Output() onSplitByPackages = new EventEmitter<{ item: Service | TaskModel; event: MouseEvent }>();
  @Output() onSelectRouteResource = new EventEmitter<{route: RouteModel, event: MouseEvent}>();

  public mutableRoute: any;
  public tasks: TaskModel[] = [];
  public allPanelIds: string[];
  public TaskType = TaskType;
  public selectedKeys: Object;
  public visibleKeys: Object;
  public taskIndexOffset: number = 1;
  public localHighlightedTaskIds = new Set<string>();
  public relationsMap: {[taskId: string]: TaskRelationModel[]} = {};

  public loading$: Observable<boolean>;
  private routeSubscription: Subscription;
  private debounceSubscription: Subscription;
  private routeUpdate$ = new Subject<RouteModel>();

  constructor(
    @Inject(RoutesComponentStore) private routesStore: RoutesComponentStore,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject('$timeout') private $timeout,
    @Inject('planningAlertsService') private planningAlertsService,
    @Inject('routesService') private routesService,
    @Inject(RoutesDragAndDropService) private routesDragAndDropService: RoutesDragAndDropService,
    @Inject(PanelService) private panelService: PanelService,
    @Inject(TasksHttpService) private tasksHttpService: TasksHttpService) {
  }

  ngOnInit() {
    // this.mutableRoute = {...this.route};
    // this.tasks = JSON.parse(JSON.stringify(this.mutableRoute.taskListExt));
    this.sortPredicate = this.sortPredicate.bind(this)

    this.routesStore.setRoutes([this.route]);
    this.routesStore.selectRoute(this.route.id);

    this.loading$ = this.routesStore.loading$;

    this.debounceSubscription = this.routeUpdate$
      .pipe(debounceTime(DEBOUNCE_TIME))
      .subscribe((route) => {
        if (!this.mutableRoute) {
          this.mutableRoute = { ...route };
          this.routesStore.subscribeTasks(_.map(route.routeTaskList, 'id'));
          this.tasks = this.routesService.getTaskList(this.mutableRoute.routeTaskList, !this.ungroupedRouteIds.has(this.mutableRoute.id));
          this._computeRelationsMap();
        } else {
          const tasksToAdd = _.differenceBy(route.routeTaskList, this.mutableRoute.routeTaskList, 'id');
          const tasksToRemove = _.differenceBy(this.mutableRoute.routeTaskList, route.routeTaskList, 'id');

          this.mutableRoute = { ...route };
          this.tasks = this.routesService.getTaskList(this.mutableRoute.routeTaskList, !this.ungroupedRouteIds.has(this.mutableRoute.id));
          this._computeRelationsMap();

          if (tasksToRemove.length) {
            this.routesStore.unsubscribeTasks(_.map(tasksToRemove, 'id'));
          }

          if (tasksToAdd.length) {
            this.routesStore.subscribeTasks(_.map(tasksToAdd, 'id'));
          }
        }

        this.taskIndexOffset = this.mutableRoute?.routeTaskList?.[0]?.taskType === 'Internal' ? 0 : 1;
      this.routesStore.setLoading(false);
        this.cdr.detectChanges();
      });

    this.routeSubscription = this.routesStore.selectedRoute$.subscribe((route: RouteModel) => {
      // this subscription triggers once for each task inside the route on update
      // for optimization we use a debounce
      this.routeUpdate$.next(route);
    });

    // // Task List Ext
    // this.routeSubscription = this.routesStore.selectedRoute$.subscribe((route: RouteModel) => {
    //   if (!this.mutableRoute) {
    //     this.mutableRoute = {...route};
    //     this.tasks = JSON.parse(JSON.stringify(route.taskListExt));
    //     this.routesStore.subscribeTasks(_.map(route.taskListExt, 'id'));
    //   } else {
    //     const tasksToAdd = _.differenceBy(route.taskListExt, this.mutableRoute.taskListExt, 'id');
    //     const tasksToRemove = _.differenceBy(this.mutableRoute.taskListExt, route.taskListExt, 'id');
    //
    //     this.mutableRoute = {...route};
    //     this.tasks = JSON.parse(JSON.stringify(this.mutableRoute.taskListExt));
    //
    //     if (tasksToRemove.length) {
    //       this.routesStore.unsubscribeTasks(_.map(tasksToRemove, 'id'));
    //     }
    //
    //     if (tasksToAdd.length) {
    //       this.routesStore.subscribeTasks(_.map(tasksToAdd, 'id'));
    //     }
    //
    //   }
    //
    //   // const currentRouteCopy = {...this.mutableRoute};
    //   //
    //   // this.mutableRoute = {...route};
    //   // this.tasks = JSON.parse(JSON.stringify(this.mutableRoute.taskListExt));
    //   //
    //   // const tasksToAdd = _.differenceBy(route.taskListExt, (currentRouteCopy?.taskListExt || []), 'id');
    //   // const tasksToRemove = _.differenceBy((currentRouteCopy?.taskListExt || []), route.taskListExt, 'id');
    //   //
    //   // if (tasksToAdd.length) {
    //   //   this.routesStore.subscribeTasks(_.map(tasksToAdd, 'id'));
    //   // }
    //   // if (tasksToRemove.length) {
    //   //   this.routesStore.unsubscribeTasks(_.map(tasksToRemove, 'id'));
    //   // }
    //
    //   this.cdr.detectChanges();
    // })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.panels || changes.resourcesDropListIds || changes.routesDropListIds) {
      const drilldownLists = [];
      const filteredPanels = _.filter(this.panels, (p) => {
        if (p.id === this.panel.id) {
          return false;
        }
        if (p.selectedTabIndex === 0) {
          drilldownLists.push(`${p.id}-drilldown`);
        }
        return true;
      })
      this.allPanelIds = _.concat(
        _.map(filteredPanels, 'id'),
        this.resourcesDropListIds || [],
        this.routesDropListIds || [],
        drilldownLists
      );
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
    }
    if (changes.selectedServiceIds) {
      this.selectedKeys = {};
      this.selectedServiceIds?.forEach((id) => {
        const tasks = this.tasks.filter((t) => {
          return t.bundleServiceIdList ? _.includes(t.bundleServiceIdList, id) : (t.serviceId === id);
        });

        tasks.forEach((a) => {
          this.selectedKeys[a.id] = true;
        });
      });
    }
    if (changes.route) {
      this.routesStore.setRoutes([this.route]);
      this.routesStore.selectRoute(this.route.id);
    }

    if (changes.ungroupedRouteIds && this.mutableRoute?.routeTaskList) {
      this.tasks = this.routesService.getTaskList(this.mutableRoute.routeTaskList, !this.ungroupedRouteIds.has(this.mutableRoute.id));
      this._computeRelationsMap();
    }
  }

  onRelationsClick(event: MouseEvent, task: TaskModel) {
    const relations = this.relationsMap[task.id] || [];
    this.panelService.open<TaskRelationsPopupComponent>(TaskRelationsPopupComponent, event, {
      relations,
      tasks$: this.tasksHttpService.getTasks([task.id])
    } as TaskRelationsPopupData);
  }

  private _computeRelationsMap() {
    this.relationsMap = {};
    this.tasks.forEach(task => {
      this.relationsMap[task.id] = dedupeRelationsByService(task.routeTaskRelations || [], task.taskSpec?.purpose);
    });
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
    this.debounceSubscription?.unsubscribe();
    this.routesStore.unSubscribeAll();
  }


  // drop(event: CdkDragDrop<string[]>) {
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(this.route.activities, event.previousIndex, event.currentIndex);
  //   } else {
  //     transferArrayItem(
  //       event.previousContainer.data,
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex,
  //     );
  //   }
  // }

  onToggleVisibleRoute(id, isVisible: boolean) {
    this.visibleKeys[id] = isVisible;
    const visibleIds = _.map(this.visibleKeys, (value, key) => {
      if (value) return key;
    });

    this.onVisibleRoutesChange.emit(_.compact(visibleIds));
  }

  onSelectedChange(task: any, isSelected: boolean) {
    let selectedIds;
    let serviceIds = task.bundleServiceIdList || [task.serviceId];

    if (isSelected) {
      selectedIds = _.uniq([...this.selectedServiceIds].concat(serviceIds));
    } else {
      selectedIds = this.selectedServiceIds.filter(id => !serviceIds.includes(id));
    }

    this.onSelectServices.emit(_.compact(selectedIds));
  }

  onHoverTask(event: { task: TaskModel; isHover: boolean }) {
    this.localHighlightedTaskIds.clear();
    if (event.isHover) {
      const counterpartIds = this.getCounterpartTaskIds(event.task);
      counterpartIds.forEach(id => this.localHighlightedTaskIds.add(id));
    }
    this.cdr.detectChanges();
  }

  private getCounterpartTaskIds(task: TaskModel): string[] {
    return this.routesService.getCounterpartTaskIds(task, this.tasks);
  }

  sortPredicate(index: number, item: CdkDrag<any>, drop: CdkDropList) {
    if (!!item.data?.serviceType) {
      return this._sortPredicateService(index, item, drop);
    } else {
      return this._sortPredicateTask(index, item, drop);
    }
  }

  enter(event: CdkDragEnter) {

  }

  drop(event: CdkDragDrop<string[]>) {
    this.routesDragAndDropService.onDropRoute(
      this.mutableRoute,
      event,
      this.selectedServiceIds,
      this.expandedRoutes,
      this.tasks
    ).then((result) => {
      if (result) {
        this.onMoveTask.emit(result.data);
      }
    });
  }

  private _canJobAddToRoute(job, route) {

    // Already In Route
    if (_.includes(route.jobIds, job.id)) {
      this.planningAlertsService.alreadyInRouteInfo();
      return false;
    }

    // Skills Match
    const jobSkills = _.get(job, 'skills', (job.jobType === 'Operation' ? ['Merchandise'] : ['Delivery']))
    const resourceSkills = _.get(route, 'resource.allocationSkills', []);
    const hasMatchingSkills = !_.difference(jobSkills, resourceSkills).length;

    if (!hasMatchingSkills) {
      this.planningAlertsService.noMatchingSkillsInfo();
      return false;
    }

    return true;

    // if (!_.includes(resourceSkills, leftoverSkill)) {
    //   const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
    //   const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
    //   this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
    //   canAddBulk = false;
    //   return false;
    // }
  }

  private _sortPredicateService(index: number, item: CdkDrag<any>, drop: CdkDropList) {

    const startIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === 'Internal' && t.taskSpec.purpose === 'StartRoute';
    })
    const endIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === 'Internal' && t.taskSpec.purpose === 'EndRoute';
    })

    if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex <= index)) {
      return false;
    } else {
      return true;
    }
  }

  private _sortPredicateTask(index: number, item: CdkDrag<any>, drop: CdkDropList) {

    const purpose = item.data.taskSpec.purpose

    const startIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === 'Internal' && t.taskSpec.purpose === 'StartRoute';
    })
    const endIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === 'Internal' && t.taskSpec.purpose === 'EndRoute';
    })

    if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex <= index)) {
      return false;
    }

    if (purpose === 'Operation') {
      return true;
    } else {


      const connectedIndexes = [];
      const itemServiceIds = _.compact(item.data.bundleServiceIdList || [item.data.serviceId]);

      drop.data.forEach((t, i) => {
        const serviceIds = _.compact(t.bundleServiceIdList || [t.serviceId]);

        if ((item.data.id !== t.id) && !!_.intersection(serviceIds, itemServiceIds).length) {
          connectedIndexes.push(i)
        }
      })

      if (connectedIndexes.length) {

        let canMove = true;

        if (purpose === 'Pickup') {
          connectedIndexes.forEach((i) => {
            if (i <= index) {
              canMove = false;
            }
          })
          return canMove;
        }

        if (purpose === 'Dropoff') {
          connectedIndexes.forEach((i) => {
            if (i >= index) {
              canMove = false;
            }
          })
          return canMove;
        }

      } else {
        return true;
      }

    }
  }
}
